import React from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Sidebar from '../Sidebar/Sidebar';
import useAuth from '../../hooks/useAuth';

// 1. Add url as an optional prop
const ModulesPage = ({ url }) => {
  const { t } = useTranslation();
  const { isLoggedIn, user } = useAuth();
  
  // 2. Use the prop if provided, otherwise fallback to the legacy env variable
  const targetUrl = url || process.env.REACT_APP_ABOUT_APP_URL;

  return isLoggedIn ? (
    <>
      <Sidebar user={user} />
      <iframe
        src={targetUrl}
        title={t('modules.iframe_title')}
        style={{
          width: '100%',
          height: '100vh',
          border: 'none',
        }}
      />
    </>
  ) : (
    <CircularProgress />
  );
};

export default ModulesPage;